import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setPaidReturnMethod } from "../lib/draft.lib";

export function useSetPaidReturnMethod(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));
  return (method: "refund" | "discount" | null) => {
    setDraft((prev) => (prev ? setPaidReturnMethod(prev, method) : prev));
  };
}
